var React = require('react');

function NavIconAutomation (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M22,0H17.6l5.5,10L17.6,20H22l5.5-10ZM13.2,0H8.8l5.5,10L8.8,20h4.4l5.5-10ZM4.4,0H0L5.5,10,0,20H4.4L9.9,10Z"}));
}

NavIconAutomation.defaultProps = {"viewBox":"0 0 27.5 20"};

module.exports = NavIconAutomation;

NavIconAutomation.default = NavIconAutomation;
